import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Div } from 'ui';
import Spinner from 'common/spinner/components/spinner';
import ErrorHandler from 'common/error/components/error-handler';
import styled from 'styled-components';
import AnnouncementCard from './announcement-card';
// eslint-disable-next-line max-len
import { fetchAnnouncementsFeed } from '../../../settings/containers/announcements/announcements-actions';

const Wrapper = styled(Div)`
  ${p => p.isHome && `
    height: 100%;
  `}
  overflow-y: auto;
`;

const AnnouncementsWrapper = styled(Div)`
  padding: 5px
`;

const AnnouncementsFeed = ({
  intl,
  isHome = false,
  filterOnCategory = null,
}) => {
  const dispatch = useDispatch();
  const {
    isLoadingSidepanelAnnouncements,
    sidepanelAnnouncements,
    isLoadingHomeAnnouncements,
    homeAnnouncements,
    announcementsSidepanelTotalCount,
    announcementsHomeTotalCount,
    announcementsFeedError,
    announcementsSidepanelOpen,
  } = useSelector(state => state.announcements);

  useEffect(() => {
    if (!announcementsSidepanelOpen) {
      dispatch(fetchAnnouncementsFeed({ isHome, category: filterOnCategory }));
    }
  }, []);

  const isLoading = isHome ? isLoadingHomeAnnouncements : isLoadingSidepanelAnnouncements;
  const data = isHome ? homeAnnouncements : sidepanelAnnouncements;
  const totalCount = isHome ? announcementsHomeTotalCount : announcementsSidepanelTotalCount;

  return (
    <Wrapper isHome={isHome}>
      <ErrorHandler type='notification' error={announcementsFeedError} />
      {isLoading && <Spinner />}
      {!isLoading && !totalCount &&
        intl.formatMessage({ id: 'announcements.home.NO_ANNOUNCEMENTS' })
      }
      {!isLoading && !!totalCount &&
        <AnnouncementsWrapper>
          {data?.map(announcement =>
            <AnnouncementCard
              key={announcement.id}
              announcement={announcement}
            />,
          )}
        </AnnouncementsWrapper>
      }
    </Wrapper>
  );
};

AnnouncementsFeed.propTypes = {
  intl: PropTypes.object,
  isHome: PropTypes.bool,
  filterOnCategory: PropTypes.string,
};

export default injectIntl(AnnouncementsFeed);
